import type { SYSState } from "../.."
import { html } from "../../"
import { T } from "../../global/globals"
import type {
  HookFormAfterCancel_Type,
  HookFormBeforeCancel_ReturnType,
  HookFormBeforeCancel_Type,
  HookFormGetCaptionRender_Type,
} from "../../global/hooks"
import {
  HookFormAfterCancel,
  HookFormBeforeCancel,
  HookFormGetCaptionRender,
} from "../../global/hooks"
import { DialogResult } from "../actions"
import type { _DialogHolderParams } from "../dialog/sysdialogholder"
import type { SYSOkCancelDeleteFooterType } from "../forms/controls/parts/okcanceldeletefooter"
import { FormIsDirty, FormRemove, FormSave } from "../forms/formapi"
import { SYSFormElement } from "../forms/sysformelement"

import type { CachedRendererData } from "./helpers"
import { _GetTableDialogTitle, FormBodyRenderer } from "./helpers"
import type { EditRowDef, OvlSysColumn } from "./table"
import { _TableFormCloseEditRow } from "./tableapi"

let cachedRendererFn: Map<string, CachedRendererData> = new Map<
  string,
  CachedRendererData
>()
export class SYSTableRowFormBig extends SYSFormElement {
  props: any
  rowData: EditRowDef
  fn: any
  async init() {
    this.rowData = this.props()
    this.formType = "SYSTableRowEdit"
    this.formId = `${this.rowData.tableDef.id}_${this.rowData.key}`
    this.fn = this.actions.app.features[this.rowData.tableDef.feature]?.hooks
    await super.init()
  }

  cancelFn = async () => {
    await _TableFormCloseEditRow(this.rowData.tableDef.id, this.rowData.key, {
      formState: this.formState,
      promptIfDirty: true,
    })
  }

  handleCancel = async () => {
    this.cancelFn()
  }

  getBody = () => {
    return FormBodyRenderer(
      this.formState,
      this.rowData.tableDef,
      this.rowData.row,
      this.rowData.data,
      this.rowData.key
    )
  }
  getHeader() {
    let def = this.rowData.tableDef
    // lets see if we have a custom caption renderer

    let captionFunctionName = HookFormGetCaptionRender.replace(
      "{subFeature}",
      this.formState.subFeature
    )

    let ovlSysState = this.rowData.data.data[this.rowData.key]
      .OvlSysState as OvlSysColumn
    let rowEditMode
    if (ovlSysState) {
      rowEditMode = ovlSysState.editRow.mode
    }
    let captionContent
    let captionTranslated
    if (this.fn?.[captionFunctionName]) {
      captionContent = this.fn[captionFunctionName](<
        HookFormGetCaptionRender_Type
      >{
        rowKey: this.rowData.key,
        formState: this.formState,
        mode: this.rowData.mode,
        tableDefId: def.id,
        row: this.rowData.row,
      })
    } else {
      if (def.options.edit.customCaption && rowEditMode) {
        let tKey =
          def.options.edit.customCaption[rowEditMode + "TranslationKey"]
        if (!tKey) {
          tKey = def.options.edit.customCaption["translationKey"]
        }
        if (tKey) {
          captionTranslated = T(tKey)
        }
      }

      captionContent = captionTranslated
    }
    if (
      !captionContent &&
      rowEditMode &&
      !def.options.edit.doNotDisplayDefaultDialogTitle
    ) {
      // now we go for the default tabledialogtitle
      let fnName
      if (rowEditMode !== "add") {
        fnName = T(
          `SYSTableRowFn${
            rowEditMode.charAt(0).toUpperCase() + rowEditMode.slice(1)
          }`
        )
      }
      let rowKey = this.rowData.key
      if (rowEditMode === "copy") {
        rowKey = ovlSysState.editRow.fromKey
      } else if (rowEditMode === "add") {
        rowKey = undefined
        fnName = T("SYSAdd")
      }
      captionContent = _GetTableDialogTitle(
        def,
        fnName,
        1,
        this.rowData.data.data,
        rowKey
      )
    }
    if (captionContent) {
      return html`
        <div class="ovl-panel__header ovl-editview-header">
          <div class="ovl-editview-headercontent">${captionContent}</div>
        </div>
      `
    }
  }
  getFooter() {
    let handleSave = async () => {
      FormSave(this.formState)
    }

    return html`
      <ovl-okcanceldeletefooter
        .props=${(state: SYSState): SYSOkCancelDeleteFooterType => {
          return {
            cancelFn: this.cancelFn,
            formState: this.formState,
            okFn: handleSave,
            deleteFn: undefined,
            dialog: "SYSTableRowEdit",
          }
        }}
      ></ovl-okcanceldeletefooter>
    `
  }
  async getUI() {
    let dialogHolderParams: _DialogHolderParams
    dialogHolderParams = {
      dialogParts: {
        header: () => this.getHeader(),
        body: () => this.getBody(),
        footer: () => this.getFooter(),

        //closedCallbackFn: this.closeEdit,
        customClass: () => {
          let def = this.rowData.tableDef
          return `ovl-table-${def.id} ovl-editform ovl-bigeditform ovl-editform-${def.id}`
        },
        dismissedCallbackFn: () => {
          if (this.formState && !this.formState.locked) {
            this.cancelFn()
          }
        },
        keyHandlerFn: (e) => {
          if (e.key === "Escape") {
            e.stopPropagation()
            if (!(this.formState && FormIsDirty(this.formState))) {
              this.cancelFn()
            }
          }
        },
      },

      dialogType: this.rowData.DialogType,
      instance: `${this.rowData.tableDef.id}_${this.rowData.key}`,
    }
    return html`<ovl-dialogholder
      .dialogHolderParams=${dialogHolderParams}
    ></ovl-dialogholder>`
  }
}
